(() => {
  const selectors = [...document.querySelectorAll('.sa-locale')];
  selectors.forEach(selector => {
    selector.addEventListener('toggle', () => {
      if (!selector.open) return;
      selectors.forEach(other => { if (other !== selector) other.open = false; });
      document.querySelectorAll('.nav-disclosure').forEach(menu => { menu.open = false; });
    });
    selector.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !selector.open) return;
      event.stopPropagation();
      selector.open = false;
      selector.querySelector('summary').focus();
    });
    selector.addEventListener('focusout', event => {
      if (event.relatedTarget && !selector.contains(event.relatedTarget)) selector.open = false;
    });
  });
  document.querySelectorAll('.nav-disclosure').forEach(menu => {
    menu.addEventListener('toggle', () => {
      if (menu.open) selectors.forEach(selector => { selector.open = false; });
    });
  });
  document.addEventListener('click', event => {
    selectors.forEach(selector => { if (!selector.contains(event.target)) selector.open = false; });
  });
})();
